import iconImage from './icon.png';

const GeneralDataUtil = {
    iconImage
}

export default GeneralDataUtil;